import React from "react"
import logosrc from "../../../images/logo.png"

const Logo = () => (
  <img src={logosrc} alt="Barnett Custom Carpenty and Fine Homes" />
)

export default Logo
